export default defineAppConfig({
    ui: {
        primary: 'blue',
        gray: 'cool',
        button: {
            color: {
                red: {
                    soft: 'bg-red-50 hover:bg-red-100 text-red-500'
                }
            }
        }
    }
})